import React from 'react';
import IAUtils from '../utils';

export function getStatementsContent(
    statements,
    sortedStrengthsToDisplay,
    studentFirstName,
    ritRanges,
    hideLearningStatements,
    strengthFilter,
    groupBy,
    studentBid,
    topicOrStandard,
    batchInfo,
    isSingleStudentMode
) {
    let learningStatements = [];

    sortedStrengthsToDisplay.forEach((strength) => {
        let statementsContent = [];
        const statementsForStrength = statements.filter((s) => s.get('strengths').includes(strength));

        if (statementsForStrength.size > 0) {
            const ritRangeForStrength = ritRanges[strength];
            const ritRange = ritRangeForStrength ? `${ritRangeForStrength.min}-${ritRangeForStrength.max}` : '';

            statementsForStrength.forEach((statement) => {
                let lsClassName = 'learning-statements';
                if (strengthFilter.includes('develop')) {
                    if (strength != 'develop' && statement.get('strengths').includes('develop')) {
                        lsClassName = 'learning-statements-gray';
                    }
                } else if (strengthFilter.includes('reinforce') && strengthFilter.includes('introduce')) {
                    if (strength !== 'develop' && statement.get('strengths').includes('develop')) {
                        lsClassName = 'learning-statements-gray';
                    }
                }

                statementsContent.push(
                    <p
                        key={statement.get('lsId') + '-' + strength + '-' + statement.get('lsName')}
                        hidden={hideLearningStatements}
                        className={lsClassName}
                    >
                        {statement.get('lsName')}
                    </p>
                );
            });

            if (statementsContent.length > 0) {
                const strengthText = IAUtils.strengthText(strength, studentFirstName, ritRange);
                learningStatements.push(
                    <h4
                        key={'strength-header' + strength + topicOrStandard}
                        hidden={hideLearningStatements}
                        className="strength-header"
                    >
                        {strengthText}
                    </h4>,
                    statementsContent
                );
            }
        }
    });

    return learningStatements;
}

const updateClassName = (classString, class1, class2, defaultClass) => {
    if (classString.indexOf(class1) >= 0) {
        classString = classString.replace(class1, class2);
    } else if (classString.indexOf(class2) >= 0) {
        classString = classString.replace(class2, class1);
    } else {
        classString += ` ${defaultClass}`;
    }
    return classString;
};

function toggleLearningStatementVisibility(event) {
    const lsId = event.target.dataset.subgoaldiv;
    const clickSource = event.target.dataset.clicksource;
    const lsContainer = document.getElementById(lsId);

    // show-hide learning statements
    lsContainer.className = updateClassName(lsContainer.className, 'hide', 'show', 'hide-collapse');

    //change orientation of chevron
    if (clickSource === 'subGoal') {
        event.target.className = updateClassName(event.target.className, 'up', 'down', 'chevron-down');
    } else {
        // handles a click on the chevron itself
        event.target.parentElement.className = updateClassName(
            event.target.parentElement.className,
            'up',
            'down',
            'chevron-down'
        );
    }
}

export function getSubGoalsToShow(
    id,
    key,
    subgoalName,
    learningStatementsForSubgoal,
    studentInfo,
    ritRanges,
    selectedSubGoalTopic,
    groupBy,
    hideLearningStatements,
    strengthFilter,
    standardTypes,
    batchInfo,
    isSingleStudentMode
) {
    const studentFirstName = studentInfo ? studentInfo.get('firstName') : 'The student';
    const studentBid = studentInfo ? studentInfo.get('studentBid') : undefined;
    const sortedStrengthsToDisplay = strengthFilter.sort(IAUtils.sortStrengths);
    const chevronClass = 'sub-goal-chevron';

    let learningStatementGroups = [];
    learningStatementsForSubgoal.forEach((statementsData, topicOrStandard) => {
        const statementGroup = statementsData.first().get('group');

        if (statementGroup === groupBy) {
            const statementElements = getStatementsContent(
                statementsData,
                sortedStrengthsToDisplay,
                studentFirstName,
                ritRanges,
                hideLearningStatements,
                strengthFilter,
                groupBy,
                studentBid,
                topicOrStandard,
                batchInfo,
                isSingleStudentMode
            );

            if (statementElements.length > 0) {
                if (!standardTypes.contains('descartes')) {
                    learningStatementGroups.push(
                        <h3 key={'topic-standard-title-' + topicOrStandard} className="topic-standard-title">
                            {topicOrStandard}
                        </h3>
                    );
                }
                learningStatementGroups = learningStatementGroups.concat(statementElements);
            }
        }
    });

    return [
        <h2
            key={'sub-goal-title-' + id}
            data-subgoaldiv={`${id}`}
            data-clicksource={'subGoal'}
            onClick={toggleLearningStatementVisibility}
            className="sub-goal"
        >
            <span className={chevronClass} data-subgoaldiv={`${id}`} data-clicksource={'chevron'} key="chevron-link" />
            {subgoalName}
        </h2>,
        <div id={`${id}`} key={`${id}`} className="grouping-container">
            {learningStatementGroups}
        </div>,
    ];
}

export default {
    getSubGoalsToShow,
};
